import React from 'react'
import useCurrentUser from '../../../hooks/use-current-user'
import Modal from '../../modals/wrapper'
import useClientLocation from '../../../hooks/use-client-location'
import useReports from '../../reports/use-reports'
import BusyModal from '../../modals/busy'
import ErrorModal from '../../modals/error'
import { find, set } from 'lodash'
import Params from './params'
import Report from './report'
import SectionHeader from './section-header'

const ReportScreen = () => {
    const [queryFields, setQueryFields] = React.useState({})
    const { isLoading: isLoadingReports, reports } = useReports()
    const { isAdmin, isFacilitator } = useCurrentUser()
    const { goBack , params} = useClientLocation()
    const reportId = params.reportId

    const report = find(reports, { id: reportId })

    React.useEffect(() => {
        //  Set default values
        if (report) {
            const query = {}
            report.params.map(p => {
                //console.log('p.fieldName:', p.fieldName)
                if (p.defaultValue) {
                    set(query, p.fieldName, p.defaultValue)
                }
                
            })
            setQueryFields(query)
        }
    }, [report])


    if (!isAdmin && !isFacilitator) {
        return null
    }

    if (isLoadingReports) {
        return (<BusyModal title='Loading report...' centered />)
    }

    if (!report) {
        return (
            <ErrorModal
                title='No report found'
                onHide={() => goBack()}
            />
        )
    }

    return (
        <Modal
            closeButton
            size='lg'
            fullWidth
            backdrop='static'
            onHide={() => goBack()}
        >
            <div
                style={{ padding: '40px' }}
            >
                <div>
                    <h3><strong>{report.name}</strong></h3>
                </div>
                <div
                    style={{
                        paddingBottom: '5px'
                    }}
                >
                    {report.description}
                </div>
                <div>
                    <SectionHeader>Parameters</SectionHeader>
                    <Params params={report.params} value={queryFields} onChange={setQueryFields} />
                    <SectionHeader/>
                    <Report queryFields={queryFields} reportId={reportId} />
                </div>
            </div>
        </Modal>
    )
}

export default ReportScreen